import React from 'react';
import LocationTemplate from './LocationTemplate';

const JamesvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Jamesville"
      stateName="North Carolina"
      countyName="Martin"
      zipCodes={["27846"]}
      latitude={35.8121}
      longitude={-76.9002}
      population={491}
      historicalFact="Established in the 1800s as a shipping port on the Roanoke River; hosted the annual Herring Festival."
      nearbyTowns={[
        "Williamston, NC",
        "Plymouth, NC",
        "Washington, NC",
        "Windsor, NC",
        "Hamilton, NC",
        "Robersonville, NC",
        "Columbia, NC",
        "Creswell, NC"
      ]}
    />
  );
};

export default JamesvillePage;